import find from 'lodash/find';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import OrderCSR from 'components/Order/OrderCSR';
import { fetchSettingsOptions } from 'lib/api';
import { actions, selectors } from 'modules/checkout';

class OrderCsrContainer extends PureComponent {
  constructor(props) {
    super(props);

    const {
      labelLanguage,
      labLocation,
      csrInformation: { jira_ticket_number, prefill_component_id, special_instructions },
    } = this.props.data;

    this.state = {
      jiraTicket: jira_ticket_number || '',
      labelLang: labelLanguage,
      returnLabLocation: labLocation,
      prefillComponentId: prefill_component_id || '',
      specialInstructions: special_instructions || '',
      editable: false,
    };
  }

  componentDidMount() {
    this.fetchSettingsOptions();
  }

  fetchSettingsOptions = async () => {
    try {
      const { languages, locations } = await fetchSettingsOptions();
      this.setState({
        languages: languages.map(lang => ({ label: lang.name, value: lang.code })),
        locations: locations.map(loc => ({ label: loc.name, value: loc.code })),
      });
    } catch (e) {
      console.error('Failed to fetch settings options.');
    }
  };

  fieldUpdate = (field, val) => {
    const { languages, locations } = this.state;
    if (field === 'labelLang') {
      const lang = find(languages, { value: val });
      return this.setState({ labelLang: { name: lang.label, code: lang.value } });
    }
    if (field === 'returnLabLocation') {
      const loc = find(locations, { value: val });
      return this.setState({ returnLabLocation: { name: loc.label, code: loc.value } });
    }
    return this.setState({ [field]: val });
  };

  onEditingToggle = () => {
    this.setState({ editable: !this.state.editable });
  };

  onSave = () => {
    const { jiraTicket, labelLang, prefillComponentId, returnLabLocation } = this.state;

    this.props.modifyConfirmationOrder({
      jiraTicket,
      labelLang,
      prefillComponentId,
      returnLabLocation,
      orderId: this.props.data.id,
    });
  };

  render() {
    return (
      <OrderCSR
        {...this.state}
        status={this.props.data.status}
        onEditingToggle={this.onEditingToggle}
        fieldUpdate={this.fieldUpdate}
        save={this.onSave}
      />
    );
  }
}

const mapState = state => ({
  data: selectors.confirmationData(state),
});

const mapDispatch = {
  modifyConfirmationOrder: actions.modifyConfirmationOrder,
};

export default connect(mapState, mapDispatch)(OrderCsrContainer);
